import { render, staticRenderFns } from "./rightBot.vue?vue&type=template&id=b1ac5f80&scoped=true&"
import script from "./rightBot.vue?vue&type=script&lang=js&"
export * from "./rightBot.vue?vue&type=script&lang=js&"
import style0 from "./rightBot.vue?vue&type=style&index=0&id=b1ac5f80&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1ac5f80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("K:\\website\\tmp\\2021.7-12\\mmlzcyy_project\\screen\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1ac5f80')) {
      api.createRecord('b1ac5f80', component.options)
    } else {
      api.reload('b1ac5f80', component.options)
    }
    module.hot.accept("./rightBot.vue?vue&type=template&id=b1ac5f80&scoped=true&", function () {
      api.rerender('b1ac5f80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/page/zzglDrawer/rightBar/rightBot.vue"
export default component.exports